import { BookingStep } from '@/features/booking'
import { translate } from '@/utils/translator'

import { ValidationContextProvider } from '../context/validationContext'
import { GuestDataContent } from './guestDataContent'
import { GuestDataSummary } from './guestDataSummary'

export const GuestDataStep = () => {
	return (
		<BookingStep
			title={translate('step-05-title')}
			instructions={translate('step-05-instructions')}
			number="05"
			step="GUEST_DATA"
			summary={<GuestDataSummary />}
		>
			<ValidationContextProvider>
				<GuestDataContent />
			</ValidationContextProvider>
		</BookingStep>
	)
}
